import React, { useEffect, useState } from "react";
import "./AccordionMenu.css";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as BacicInfoIcon } from "../../../assets/images/client-dashboard/sidebar-basicinfo.svg";
import { ReactComponent as DropIcon } from "../../../assets/images/client-dashboard/sidebar-drop.svg";

const AccordionMenu = ({ activeTab, setActiveTab, items, title, Icon }) => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isCurrentPathInAccordion = items.some((item) =>
      location.pathname.includes(item.link)
    );

    // If the current path is in the accordion, keep it expanded
    if (isCurrentPathInAccordion) {
      setExpanded(true);
    } else {
      // Otherwise, collapse it
      setExpanded(false);
    }
  }, [location, items]);
  return (
    <div
      className={`${
        expanded
          ? "custom__accordionmenu_wrapactive"
          : "custom__accordionmenu_wrap"
      }`}
    >
      <div
        className={`${
          expanded
            ? "custom__accordionmenu_headeractive"
            : "custom__accordionmenu_header"
        }`}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="custom__accordionmenu_headerleft">
          <Icon stroke={expanded ? "#181B31" : "white"} />
        </div>
        <div className="custom__accordionmenu_headerright">{title}</div>
        <DropIcon
          stroke={expanded ? "#181B31" : "white"}
          className={`${
            expanded
              ? "custom__accordionmenu_headericnactive"
              : "custom__accordionmenu_headericn"
          }`}
        />
      </div>
      <div
        className={`${
          !expanded
            ? "custom__accordionmenu_listexpanded"
            : "custom__accordionmenu_list"
        }`}
      >
        {items.map((item) => {
          let Icon = item.Icon;
          return (
            <>
              <hr />
              <div className="custom__accordionmenu_listItem">
                <NavLink
                  className={({ isActive }) => {
                    isActive && setActiveTab(item.link);
                    return isActive
                      ? "client__dashboard_draweritemactive"
                      : "client__dashboard_draweritem";
                  }}
                  style={{
                    borderRadius: "0px",
                    maxWidth: "100%",
                    marginBottom: "0px",
                  }}
                  to={item.link}
                >
                  <div className="client__dashboard_ditmleft">
                    <Icon
                      stroke={activeTab === item.link ? "#181B31" : "white"}
                    />
                  </div>
                  <div className="client__dashboard_ditmright">{item.text}</div>
                </NavLink>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default AccordionMenu;
